import type RequestOptions from '@/types/RequestOptions'
export const useApiStore = defineStore('apiStore', {
  state: () => ({
  }),
  actions: {
    async request (url: string, options: RequestOptions = {}, api: string = 'financeiro', loading: boolean = true) {
      const config = useRuntimeConfig()

      try {
        if (loading) {
          useStore().loading = true
        }
        const { method = 'GET', headers: optionsHeaders, body: requestBody, ...restOptions } = options
        const defaultHeaders = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${useAutenticacaoStore().retornarToken}`,
        }
        const mergedHeaders = {
          ...defaultHeaders,
          ...optionsHeaders,
        }
        const defaultOptions: RequestInit = {
          method,
          headers: mergedHeaders,
          body: requestBody !== undefined ? JSON.stringify(requestBody) : null,
          ...restOptions,
        }
        if (!url.startsWith('/')) {
          url = `/${url}`
        }
        let urlBase = ''
        switch (api) {
          case 'financeiro':
            urlBase = config.public.baseURL
            break
          case 'legado':
            urlBase = config.public.baseURLLegado
            break
          default:
            urlBase = config.public.baseURL
        }

        const response = await $fetch<Response>(urlBase + url, defaultOptions)
        return response
      } catch ({ response, data }) {
        // if error is 4xx, redirect to login
        if (!response || ([400, 401, 402, 403, 404].includes(response.status) && data.error && ['token_invalid', 'token_expired', 'token_not_provided'].includes(data.error))) {
          // debugger
          // console.log('Erro de autenticação')
          useAutenticacaoStore().$reset()
          useUsuarioStore().$reset()
          useDashboardStore().$reset()
          useNotificacaoStore().$reset()
          useOrcamentoStore().$reset()
          usePrestacaoDeContaStore().$reset()
          return navigateTo(this.redirectBackWhenSignedUrl(), {
            external: true,
          })
        } else {
          throw data
        }
      } finally {
        if (loading) {
          useStore().loading = false
        }
      }
    },
    async upload (url: string, formData: FormData, method = 'POST', api: string = 'financeiro', loading: boolean = true) {
      const config = useRuntimeConfig()

      try {
        if (loading) {
          useStore().loading = true
        }
        let urlBase = ''
        switch (api) {
          case 'financeiro':
            urlBase = config.public.baseURL
            break
          case 'legado':
            urlBase = config.public.baseURLLegado
            break
          default:
            urlBase = config.public.baseURL
        }
        const response = await $fetch(urlBase + url, {
          method,
          body: formData,
          data: formData,
          headers: {
            Authorization: `Bearer ${useAutenticacaoStore().retornarToken}`,

          },
        })
        return response
      } catch (error) {
        if (error.data?.message) {
          throw new Error(error.data.message)
        }
        throw new Error(error)
      } finally {
        if (loading) {
          useStore().loading = false
        }
      }
    },
    async download (url: string, options: RequestOptions = {}, api: string = 'financeiro', loading: boolean = true) {
      const config = useRuntimeConfig()

      try {
        if (loading) {
          useStore().loading = true
        }
        let urlBase = ''
        switch (api) {
          case 'financeiro':
            urlBase = config.public.baseURL
            break
          case 'legado':
            urlBase = config.public.baseURLLegado
            break
          default:
            urlBase = config.public.baseURL
        }
        const response = await fetch(urlBase + url, {
          method: options.method || 'GET',
          headers: {
            Authorization: `Bearer ${useAutenticacaoStore().retornarToken}`,
          },
        })

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const blob = await response.blob()
        return blob
      } catch (error) {
        console.error('Download error:', error)
        throw error
      } finally {
        if (loading) {
          useStore().loading = false
        }
      }
    },
    redirectBackWhenSignedUrl () {
      const config = useRuntimeConfig()

      return `${config.public.loginUrl}?continuar=${config.public.autenticacaoURL}?token=Bearer {token}`
    },
  },
})
